var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 6.66667C1.75 3.95127 3.95127 1.75 6.66667 1.75H14.1667C14.5809 1.75 14.9167 2.08579 14.9167 2.5C14.9167 2.91421 14.5809 3.25 14.1667 3.25H6.66667C4.7797 3.25 3.25 4.7797 3.25 6.66667V13.3333C3.25 13.7475 2.91421 14.0833 2.5 14.0833C2.08579 14.0833 1.75 13.7475 1.75 13.3333V6.66667ZM5.08333 7.5C5.08333 6.16531 6.16531 5.08333 7.5 5.08333H15.8333C17.1681 5.08333 18.25 6.16532 18.25 7.5V15.8333C18.25 17.168 17.168 18.25 15.8333 18.25H7.5C6.16532 18.25 5.08333 17.1681 5.08333 15.8333V7.5Z",
    fill: "#CDCED6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.20f97c1c71ae9d8b55a323023f919ae7.svg";
export { ForwardRef as ReactComponent };